import { render, staticRenderFns } from "./ContentTags.vue?vue&type=template&id=675e8a5f"
import script from "./ContentTags.vue?vue&type=script&lang=js"
export * from "./ContentTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports